var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mb-3",attrs:{"justify":"center"}},[_c('DaySelector',{on:{"select":_vm.load}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }